import { render } from "./roadmap.vue?vue&type=template&id=4a6d2a66&scoped=true"
import script from "./roadmap.vue?vue&type=script&lang=js"
export * from "./roadmap.vue?vue&type=script&lang=js"

import "./roadmap.vue?vue&type=style&index=0&id=4a6d2a66&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6d2a66"]])

export default __exports__